<form [formGroup]="form" (ngSubmit)="applyFilters()" class="h-screen bg-bg-primary grid grid-rows-[auto_auto_1fr_auto]">
  <div class="flex flex-row justify-between p-5">
    <lds-button [variant]="ButtonVariant.TERTIARY" [iconLeft]="Icon.ARROW_LEFT" (click)="exitFiltersView()">
      <h2 class="text-title-3-desktop">{{ 'filters' | translate }}</h2>
    </lds-button>
    <lds-button (click)="clearAllFilters()" [variant]="ButtonVariant.LINK">{{ 'clearAll' | translate }}</lds-button>
  </div>
  <div class="border-y border-border-secondary p-5">
    <lds-toggle formControlName="openNow" [label]="'openNow' | translate"></lds-toggle>
  </div>
  <lds-accordion>
    <lds-accordion-item
      [title]="'services' | translate"
      [panelIcon]="Icon.PUZZLE_PIECE_01"
      formArrayName="services"
      (isOpened)="onFilterGroupToggle($event, 'services')"
    >
      <div class="flex flex-col gap-4 items-start">
        @for (service of servicesControl().controls; track $index; let i = $index) {
          @if (showAllServices() || i < servicesLimit()) {
            <div [formGroupName]="i">
              <lds-checkbox formControlName="checked">
                <span class="text-body-2-desktop font-medium" label> {{ service.value.displayName }}</span>
              </lds-checkbox>
            </div>
          }
        }
        @if (!isDesktop() && !showAllServices()) {
          <lds-button [variant]="ButtonVariant.LINK" (click)="onViewAllServices()">
            {{ 'viewAll' | translate }}
          </lds-button>
        }
      </div>
    </lds-accordion-item>
    <lds-accordion-item
      [title]="'fuels' | translate"
      [panelIcon]="Icon.DISPENSER"
      formArrayName="fuels"
      (isOpened)="onFilterGroupToggle($event, 'fuels')"
    >
      <div class="flex flex-col gap-4 items-start">
        @for (fuel of fuelsControl().controls; track $index; let i = $index) {
          <div [formGroupName]="i">
            <lds-checkbox formControlName="checked" class="[&>[data-testid='checkbox-container']]:items-center">
              <div label class="text-body-2-desktop font-medium">
                @if (fuel.value.icon) {
                  <img class="inline" [src]="fuel.value.icon" alt="" />
                }
                <span> {{ fuel.value.displayName }} </span>
              </div>
            </lds-checkbox>
          </div>
        }
      </div>
    </lds-accordion-item>
  </lds-accordion>
  <div class="block p-5 border-t border-border-secondary">
    <lds-button [type]="ButtonType.SUBMIT" [expand]="ButtonExpand.FULL" [disabled]="!this.form.dirty">{{
      'apply' | translate
    }}</lds-button>
  </div>
</form>
